import notice from '@/view/notice/noticelist'

const noticeRouter = [
  {
    path: '/notice/list.html',
    name: 'notice-list-form',
    component: notice,
    meta: {
      title: '我的消息'
    }
  }
]

export default noticeRouter



// WEBPACK FOOTER //
// ./src/router/notice/notice.js